import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class FacilityRequestsApi extends Api {
  constructor() {
    super('facility/facility_requests/');
  }

  approve(id, data) {
    return this.buildQuery(
      'post',
      {
        data,
      },
      `${id}/approve`,
    );
  }

  getExcel = (params) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/facility/facility_requests.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  };
  createRequest(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      '',
    );
  }

  deleteFile(id, fileId) {
    return this.buildQuery(
      'delete',
      {
        data: {
          ids: fileId,
        },
      },
      `${id}/remove_attachments`,
    );
  }

  updateRequest(id, data) {
    return this.buildQuery(
      'put',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      id,
    );
  }
}

export default FacilityRequestsApi;
